import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

// import shoppingImage from '../../assets_user/img/shopping-cart.png';
// import orderImage from '../../assets_user/img/order-image.png';
// import heartImage from '../../assets_user/img/love-image.png'

import { useBlogContext } from '../../../fetchdata/BlogContext';
import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
import eraseCookie from '../../../helper/eraseCookie';
import HeaderPage from '../../components/HeaderPage';
import NavBar from '../../components/NavBar';

const Account = () => {

  const decryptdatajson = getDecryptData();


  const isLoginFromLocalStorage = getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      // localStorage.clear();
      eraseCookie('token')
      setIsLogin(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteAccount = async () => {
    if (!decryptdatajson?._id) {
      toast.error("User not found");
      return;
    }

    const confirmed = window.confirm("Are you sure you want to delete your account?");
    if (!confirmed) return;

    try {
      const response = await axiosInstance.put(`/admin/soft-delete-user/${decryptdatajson._id}`);
      dispatch(authActions.logout());
      eraseCookie('token');
      setIsLogin(false);
      toast.success(response.data?.message || "Account deleted successfully");
      navigate("/login");
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response?.data?.message || "Error deleting account");
    }
  };

  const isActive = (path) => {
    return window.location.pathname === path ? 'active' : '';
  };


  return (
    <>

      <HeaderPage title={'My Profile'} />
   <main className="page-content space-top dz-gradient-shape pb-4 px-0">

 <div className='px-3 mt-2'>

{isLogin ? (
  <div className="dz-list style-3">
    <ul className="mb-3">

      {decryptdatajson && decryptdatajson.type !== 1 ? (
        <li>
          <Link className="item-content item-link" to="/account/all-order">
            <div className="dz-icon icon-xs icon-fill">
              <i className="ri-shopping-bag-3-line"></i>
            </div>
            <div className="dz-inner">
              <span className="title">My Order</span>
              <div className="link-desc">Manage all my Orders</div>
            </div>
          </Link>
        </li>
      ) : (
        <>
          <li>
            <Link className="item-content item-link" to="/all-order">
              <div className="dz-icon icon-xs icon-fill">
                <i className="ri-shopping-bag-3-line"></i>
              </div>
              <div className="dz-inner">
                <span className="title">All Order</span>
                <div className="link-desc">Manage all my Orders</div>
              </div>
            </Link>
          </li>

          <li>
            <Link className="item-content item-link" to="/pending-order">
              <div className="dz-icon icon-xs icon-fill">
                <i className="ri-time-line"></i>
              </div>
              <div className="dz-inner">
                <span className="title">Pending Order</span>
                <div className="link-desc">Manage all my Orders</div>
              </div>
            </Link>
          </li>

          <li>
            <Link className="item-content item-link" to="/complete-order">
              <div className="dz-icon icon-xs icon-fill">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="dz-inner">
                <span className="title">Complete Order</span>
                <div className="link-desc">Manage all my Orders</div>
              </div>
            </Link>
          </li>

          <li>
            <Link className="item-content item-link" to="/cancel-order">
              <div className="dz-icon icon-xs icon-fill">
                <i className="ri-close-circle-line"></i>
              </div>
              <div className="dz-inner">
                <span className="title">Cancel Order</span>
                <div className="link-desc">Manage all my Orders</div>
              </div>
            </Link>
          </li>
        </>
      )}

      {/* Profile */}
      <li>
        <Link className="item-content item-link" to="/account/profile">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-user-3-line"></i>
          </div>
          <div className="dz-inner">
            <span className="title">My Profile</span>
            <div className="link-desc">Change your profile details</div>
          </div>
        </Link>
      </li>

      {/* Password */}
      <li>
        <Link className="item-content item-link" to="/account/password">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-lock-password-line"></i>
          </div>
          <div className="dz-inner">
            <span className="title">Change Password</span>
            <div className="link-desc">Change your profile password</div>
          </div>
        </Link>
      </li>

      {/* Support */}
      <li>
        <Link className="item-content item-link" to="/account/support">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-customer-service-2-line"></i>
          </div>
          <div className="dz-inner">
            <span className="title">Help & Support</span>
            <div className="link-desc">Contact Us for help and support</div>
          </div>
        </Link>
      </li>




      {/* Logout */}
      <li>
        <button type="button" onClick={handleDeleteAccount} className="item-content item-link border-0 bg-transparent w-100 text-start">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-delete-bin-line"></i>
          </div>
          <div className="dz-inner">
            <span className="title">Delete Account</span>
            <div className="link-desc">Permanently delete or disable your account</div>
          </div>
        </button>
      </li>

      <li>
        <Link onClick={handleLogout} className="item-content item-link" to="#">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-logout-box-r-line"></i>
          </div>
          <div className="dz-inner">
            <span className="title">Logout</span>
            <div className="link-desc">Logout your account</div>
          </div>
        </Link>
      </li>

    </ul>
  </div>
) : (
  <div className="dz-list style-3">
    <ul className="mb-3">

      <li>
        <Link className="item-content item-link" to="/account/support">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-customer-service-2-line"></i>
          </div>
          <div className="dz-inner">
            <span className="title">Help & Support</span>
            <div className="link-desc">Contact Us for help and support</div>
          </div>
        </Link>
      </li>

       <li>
        <Link className="item-content item-link" to="/signup-user">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-car-fill"></i>
          </div>
          <div className="dz-inner">
          <span className="title">Become a Driver</span>
         <div className="link-desc">Create an account to start driving</div>
          </div>
        </Link>
      </li>


      <li>
        <Link className="item-content item-link" to="/login">
          <div className="dz-icon icon-xs icon-fill">
            <i className="ri-login-box-line"></i>
          </div>
          <div className="dz-inner">
            <span className="title">Login</span>
            <div className="link-desc">Login your account</div>
          </div>
        </Link>
      </li>

    </ul>
  </div>
)}

</div>


        <NavBar />
      </main>

    </>
  )
}

export default Account
